import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPopupConfigService } from 'ui-ng-popup';
import { IAppointmentReasonUsersourceModel } from '../../usersources/appointment_reason_usersource';
import { IAppointmentLocationsOrganizersUsersourceModel } from '../../usersources/usersources_module';
import { IAvailableWalkinTimesLocations, IAvailableWalkinTimesUsers } from '../../views/walkin_times/walkin_times';

export class AppointmentDropin {
  private location: IAvailableWalkinTimesLocations;
  private serviceId: number = 0;
  private careUnitId: number = 0;
  private organizer: IAvailableWalkinTimesUsers;
  private firstAvailable: boolean = false;
  private staffId?: number = undefined;
  private courseId?: number = undefined;
  private modalMessage: string = '';
  constructor(
    private dropinAppointmentCommand: ICommand,
    private ngAppointmentReasonUsersource: IAppointmentReasonUsersourceModel,
    private ngPopupService: IPopupConfigService,
    private log: any,
    private $state: ng.ui.IStateService,
    private ngAppointmentLocationsOrganizersUsersource: IAppointmentLocationsOrganizersUsersourceModel
  ) {}

  $onInit() {
    this.init();
  }

  $onChanges() {
    this.init();
  }

  get canCheckIn() {
    return this.firstAvailable
      ? this.location.can_dropin_with_first_available
      : this.organizer.currently_available_for_dropins;
  }

  init() {
    this.serviceId = _4.get(this.ngAppointmentReasonUsersource.selectedService, 'id');
    this.staffId = _4.get(this.organizer, 'user_id', undefined);
    this.careUnitId = _4.get(this.ngAppointmentReasonUsersource.selectedType, 'id');
    this.modalMessage = this.firstAvailable
      ? `You have dropped in to see the first available staff member.  Look out for an email, text, or phone call for next steps.`
      : `
      You have dropped in to see ${this.organizer.name}.  Look out for an email, text, or phone call for next steps.`;
    this.courseId = _4.get(this.ngAppointmentLocationsOrganizersUsersource.selectedCourse, 'id');
  }

  checkin() {
    this.dropinAppointmentCommand(
      this.location.location_id,
      this.serviceId,
      this.careUnitId,
      this.staffId,
      this.courseId
    )
      .then((response: any) => {
        this.ngPopupService.show({
          title: 'Appointment Drop-in',
          body: this.modalMessage,
          completeButtonText: 'Okay',
          acceptOnly: true,
          completeCallback: () => {
            this.$state.go('my.myAppointments.upcoming');
          }
        });
      })
      .catch((error: any) => {
        this.log.error(error);
        this.ngPopupService.show({
          title: 'Appointment Drop-in',
          body: _.first(_.get(error, 'data.metadata.errors')),
          completeButtonText: 'Okay',
          acceptOnly: true
        });
      });
  }
}

angular
  .module('capability-ng-appointments')
  .component('appointmentDropin', {
    bindings: {
      location: '<',
      organizer: '<',
      firstAvailable: '<'
    },
    templateUrl: 'capability-ng-appointments/src/components/appointment_dropin/appointment_dropin.html',
    controller: 'appointmentDropinController'
  })
  .controller('appointmentDropinController', AppointmentDropin);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointment_dropin/appointment_dropin.ts